import React from 'react';
import * as elog from '@reverbdotcom/commons/src/elog';
import { useFiveDigitLocale } from '@reverbdotcom/commons/src/user_five_digit_locale_hook';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import { adyenCheckout } from '@reverbdotcom/commons/src/adyen_checkout';
import { SCAState, SCASubType, SCAType } from './adyen_sca_hook';

interface Props {
  selector: string;
  action: PaymentAction;
  onAdditionalDetails(state: SCAState): void;
  enabled?: boolean;
  environment?: string;
  clientKey?: string;
}

// For 3DS2 configuration see https://docs.adyen.com/online-payments/3d-secure/native-3ds2/web-component
// For 3DS1 redirect configuration see https://docs.adyen.com/online-payments/3d-secure/redirect-3ds2-3ds1/web-component
export function useLegacyAdyenSCA({ selector, action, onAdditionalDetails, clientKey, environment, enabled = true }: Props) {
  const locale = useFiveDigitLocale();

  React.useEffect(() => {
    if (!enabled || !environment || !clientKey) {
      return;
    }

    elog.info('use_adyen_sca_action', { action });

    function onError(error) {
      elog.error('use_adyen_sca_error', { actionType: action.type, ...error }, error.errorCode);
    }

    function options() {
      if (action.type === SCAType.Challenge) {
        return { size: '05' };
        // @ts-ignore Unnecessary 'else' after 'return'
      } if (action.subtype === SCASubType.Challenge) { // in checkout api v67 & adyen components 4.9.0
        return { challengeWindowSize: '05' };
      }
      return {};
    }

    const configuration = {
      clientKey,
      environment,
      locale,
      onAdditionalDetails,
      onError,
    };

    const checkout = adyenCheckout({ configuration });

    checkout.createFromAction(action, options()).mount(selector);
  }, [locale, selector, environment, clientKey, action, onAdditionalDetails, enabled]);
}
